import '@/@fake-db/db'
import { i18n } from '@/plugins/i18n'
import '@/styles/styles.scss'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import _ from 'lodash'
import { VueMaskDirective } from 'v-mask'
import Vue from 'vue'
import Notify from 'vue-notifyjs'
import 'vue-notifyjs/themes/default.css'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import './plugins/acl'

import VueRx from 'vue-rx'

import filters from './filters'
import LaravelEchoPlugin from './plugins/laravel-echo'
import vuetify from './plugins/vuetify'
import router from './router'
import { AuthService } from './services/auth.service'
import store from './store'
import routePaginationMixin from './mixins/routePagination'

import 'vuejs-clipper/dist/vuejs-clipper.css'
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd.min'

const $authService = new AuthService()

// Routes flagged `resource: 'Public'` (token links such as the video editor's
// running order) must render for a logged-out visitor. The redirect below used
// to run for every URL, so those links bounced to the accounts login before the
// router ever saw them.
const isPublicRoute = () => {
	const { route } = router.resolve(window.location.pathname + window.location.search + window.location.hash)

	// resolve() runs a route's redirect function. The root route redirects through
	// getDefaultRoute(), which answers 'error-403' while nobody is logged in yet —
	// that (Public) target used to make "/" look public, skip the login and land on
	// a 403 whenever the URL was typed. A redirected route is never a public link.
	if (route.redirectedFrom) return false

	return route.meta.resource === 'Public'
}

const boot = () => {
	Vue.config.productionTip = false
	Vue.use(Notify)
	Vue.use(Vuelidate)

	Vue.use(VueRx)
	Vue.use(VuejsClipper)

	Vue.directive('mask', VueMaskDirective)
	Vue.set(Vue.prototype, '$_', _)

	Vue.prototype.$authService = $authService
	Vue.use(LaravelEchoPlugin)
	Vue.use(CKEditor)
	Vue.mixin(routePaginationMixin)

	Vue.config.productionTip = false
	Vue.use(Notify)
	Vue.use(Vuelidate)
	Vue.directive('mask', VueMaskDirective)
	Vue.set(Vue.prototype, '$_', _)

	const moment = require('vue-moment')
	Vue.use(moment)
	Vue.prototype.moment = moment

	new Vue({
		router,
		store,
		i18n,
		vuetify,
		filters,
		render: h => h(App),
	}).$mount('#app')

	// Resume the navigation that triggered a stale-chunk auto-reload
	// (see router.onError in ./router) so the user lands where they were
	// actually headed instead of wherever the reload happened to land.
	const redirectPath = sessionStorage.getItem('chunk_load_redirect')
	if (redirectPath) {
		sessionStorage.removeItem('chunk_load_redirect')
		if (redirectPath !== router.currentRoute.fullPath) {
			router.replace(redirectPath)
		}
	}
}

if (isPublicRoute()) {
	boot()
} else {
	$authService.isAuthenticated().then(isAuthenticated => {
		if (!isAuthenticated) {
			if (process.env.NODE_ENV === 'development' && !process.env.VUE_APP_ACCOUNTS_URL) {
				return document.write('<h1>Please check the Authenticate section in your README.md before continuing</h1>')
			}
			window.location =
				process.env.VUE_APP_ACCOUNTS_URL.replace(/\/$/, '') + '/logout?redirect_to=' + window.location.href
			return
		}

		boot()
	})
}
